import { useCallback, useEffect, useState } from 'react';

export interface UseImageUrlBaseProps {
  /**
   * @description the hostname to fetch the image from
   * @example {string} "https://engagecraftfantasydev.blob.core.windows.net"
   * @default {string} "https://engagecraftfantasydev.blob.core.windows.net"
   */
  hostname: string;
  pathname: string;
  ext: string;
}

export interface UseImageUrlProps extends UseImageUrlBaseProps {
  value: string;
  fallbackValue: string;
}

export const useImageUrl = ({
  value,
  fallbackValue,
  hostname,
  pathname,
  ext,
}: UseImageUrlProps) => {
  const [isError, setError] = useState(false);

  useEffect(() => {
    setError(false);
  }, [value]);

  const _value = isError ? fallbackValue : value;
  const _url = new URL([pathname, `${_value}.${ext}`].filter(v => !!v).join('/'), hostname);

  const onError = useCallback(() => {
    setError(true);
  }, []);

  return {
    value: _value,
    url: _url,
    onError,
  };
};
